import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { getStatus, getNextNumber, getOrderUrl } from './../../utils/order';
import { STATUS_PROGRESS, STATUS_COMPLETE } from './../../store/orders/actions';


const OrderNextButton = props => {
    const { visible, enabled, url } = props;

    if (!visible) {
        return null;
    }

    if (!enabled) {
        // no action
        return (
            <button disabled className="btn btn-arrow">Check next order</button>
        );
    }

    return (
        <Link to={url} className="btn btn-arrow btn-arrow-danger">Check next order</Link>
    );
};

const mapStateToProps = (state, ownProps) => {
    const { isLoading, orderNumber } = ownProps;
    const order = state.orders[orderNumber];

    if (isLoading || !order) {
        return { visible: false };
    }
    const status = getStatus(order);
    if (status !== STATUS_COMPLETE && status !== STATUS_PROGRESS) {
        return { visible: false };
    }
    const nextNumber = getNextNumber(orderNumber, state);
    if (!nextNumber) {
        return { visible: false };
    }
    const enabled = status === STATUS_COMPLETE;
    if (!enabled) {
        return { visible: true, enabled: false };
    }
    return { visible: true, enabled: true, url: getOrderUrl(nextNumber, state) };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderNextButton);



// WEBPACK FOOTER //
// ./src/components/order/OrderNextButton.js